import { registerApplication, getAppNames } from "single-spa";
import singleSpaHtml from "../helpers/htmlRoute";
import postLogoutHtml from "../views/postLogout.html";

export function interpolate(content: string, data: any): string {
  return content.replace(/\${(.*?)}/g, (match, group) => {
    return data[group.trim()] || match;
  });
}

export const postLogoutPage = singleSpaHtml({
  template: (props) => {
    return interpolate(postLogoutHtml, props);
  },
});

export const staticRoutesConfig = [
  {
    opts: {
      name: "postLogout",
      app: postLogoutPage,
      activeWhen: "/p/logout",
    },
    props: () => {
      const loginUrl = localStorage.getItem("loginUrl");
      return {
        loginUrl,
      };
    },
  },
];

export function registerStaticRouting() {
  staticRoutesConfig.forEach((route) => {
    const routeOptions = {
      ...route.opts,
      customProps: route.props(),
    };
    if (!getAppNames().includes(routeOptions.name)) registerApplication(routeOptions);
  });
}
